import PropTypes from 'prop-types';
import Button from 'components/UI/Button';
import Select from 'components/UI/Select';
import { ReactComponent as CalendarIcon } from 'assets/icons/calendar.svg';
import { formatVisitDateDisplay } from 'modules/digitalLoan/visitSchedule';
import { buildCappedLoanMessage } from '../utils/cappedLoanMessage';
import { formatDigitalLoanMoney } from '../utils/moneyInput';

const PreOfferScreen = ({
  literals,
  preOffer,
  selectedVisitDate,
  selectedVisitTimeSlot,
  onVisitDateChange,
  onVisitTimeChange,
  onFinish,
  isSubmitting = false,
}) => {
  const cappedMessage = buildCappedLoanMessage(
    literals.cappedAmount,
    preOffer,
  );
  const dateOptions = (preOffer?.availableVisitDates || []).map((date) => ({
    value: date,
    label: formatVisitDateDisplay(date),
  }));
  const timeOptions = (preOffer?.availableVisitTimeSlots || []).map((slot) => ({
    value: slot,
    label: slot,
  }));

  return (
    <div className='full-screen-container digital-loan-preoffer'>
      <div className='screen-content digital-loan-preoffer__scroll'>
        <h1 className='digital-loan-phase2__title digital-loan-preoffer__title'>
          {literals.title}
        </h1>
        <p className='digital-loan-phase2__body mb-4'>{literals.subtitle}</p>

        <div className='digital-loan-summary-block'>
          <h2 className='digital-loan-summary-block__title'>{literals.loanSection}</h2>
          <div className='digital-loan-summary-block__row'>
            <span className='digital-loan-summary-block__label'>{literals.amountLabel}</span>
            <strong>{formatDigitalLoanMoney(preOffer?.amount)}</strong>
          </div>
          {cappedMessage && (
            <p className='digital-loan-phase2__body mt-2' role='status'>
              {cappedMessage}
            </p>
          )}
          <div className='digital-loan-summary-block__row'>
            <span className='digital-loan-summary-block__label'>{literals.termLabel}</span>
            <strong>
              {preOffer?.term}
              {' '}
              {literals.termUnit}
            </strong>
          </div>
          <div className='digital-loan-summary-block__row'>
            <span className='digital-loan-summary-block__label'>{literals.frequencyLabel}</span>
            <strong>{preOffer?.paymentFrequency}</strong>
          </div>
        </div>

        <div className='digital-loan-summary-block'>
          <h2 className='digital-loan-summary-block__title'>{literals.guaranteeSection}</h2>
          <div className='digital-loan-preoffer__guarantee'>
            <span>{preOffer?.guaranteeName}</span>
            {preOffer?.guaranteeImage && (
              <img
                src={preOffer.guaranteeImage}
                alt={preOffer.guaranteeName}
                className='digital-loan-preoffer__guarantee-img'
              />
            )}
          </div>
        </div>

        <div className='digital-loan-summary-block'>
          <h2 className='digital-loan-summary-block__title'>{literals.visitSection}</h2>
          <p className='digital-loan-phase2__body mb-3'>{literals.visitHint}</p>
          <div className='digital-loan-preoffer__visit-card'>
            <CalendarIcon className='digital-loan-preoffer__calendar' aria-hidden='true' />
            <Select
              className='digital-loan-preoffer__visit-select'
              name='visitDate'
              placeholder={literals.selectDay}
              options={dateOptions}
              value={selectedVisitDate || ''}
              onChange={onVisitDateChange}
              disabled={isSubmitting}
            />
          </div>
          {selectedVisitDate && (
            <div className='digital-loan-preoffer__visit-card mt-3'>
              <Select
                className='digital-loan-preoffer__visit-select'
                name='visitTime'
                placeholder={literals.selectTime}
                options={timeOptions}
                value={selectedVisitTimeSlot || ''}
                onChange={onVisitTimeChange}
                disabled={isSubmitting}
              />
            </div>
          )}
        </div>
      </div>
      <div className='screen-actions'>
        <Button
          text={literals.finish}
          disabled={!selectedVisitDate || !selectedVisitTimeSlot || isSubmitting}
          loading={isSubmitting}
          onClick={onFinish}
        />
      </div>
    </div>
  );
};

PreOfferScreen.propTypes = {
  literals: PropTypes.object.isRequired,
  preOffer: PropTypes.object,
  selectedVisitDate: PropTypes.string,
  selectedVisitTimeSlot: PropTypes.string,
  onVisitDateChange: PropTypes.func.isRequired,
  onVisitTimeChange: PropTypes.func.isRequired,
  onFinish: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool,
};

export default PreOfferScreen;
